import React, { useState, useEffect } from 'react';
import usePWAInstall from '../hooks/usePWAInstall';
import '../styles/PWAInstallPrompt.css';

const PWAInstallPrompt = () => {
  const { canInstall, promptInstall } = usePWAInstall();
  const [dismissed, setDismissed] = useState(false);

  // Don't show if dismissed within last 7 days
  useEffect(() => {
    const dismissedAt = localStorage.getItem('pwaPromptDismissed');
    if (dismissedAt) {
      const weekInMs = 7 * 24 * 60 * 60 * 1000;
      if (Date.now() - parseInt(dismissedAt, 10) < weekInMs) {
        setDismissed(true);
      }
    }
  }, []);

  const handleInstallClick = async () => {
    await promptInstall();
  };

  const handleDismiss = () => {
    setDismissed(true);
    // Save dismissal in localStorage to not show again for a while
    localStorage.setItem('pwaPromptDismissed', Date.now().toString());
  };

  if (!canInstall || dismissed) {
    return null;
  }

  return (
    <div className="pwa-install-prompt">
      <div className="pwa-install-content">
        <button className="pwa-dismiss" onClick={handleDismiss}>
          ✕
        </button>
        <div className="pwa-icon">
          <img src="/UCMA_maskable_512.png" alt="UCMAAPP" />
        </div>
        <div className="pwa-text">
          <h3>Install UCMAApp</h3>
          <p>Install our app locally on your device</p>
        </div>
        <button className="pwa-install-button" onClick={handleInstallClick}>
          Install
        </button>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
